import React, { FC } from 'react'
import { RequestParams } from 'Models'
import { useSelector } from 'react-redux'
import { useAppDispatch, useEffectOnce } from 'Src/hooks'
import { gridSelectors } from 'Modules'
import {
	interfaceElementSlice,
	interfaceElementsSelector,
	gridConfigIE,
	InterfaceElementModel,
} from 'Pages/interfaceElement'
import { GridRow, RenderGridRowProps } from 'LibNeo'
import { CustomHeader } from './CustomHeader'
import { CustomColumns } from './CustomColumns'
import { OpenedComponent } from './OpenedComponent'
import { GridWrapper } from './styled'

const actions = {
	getAll: interfaceElementSlice.actions.getAll,
}

export const GridIE: FC = () => {
	const { getAll } = useAppDispatch(actions)
	const roleElements = useSelector(interfaceElementsSelector.getAllRole)
	const params = useSelector(interfaceElementsSelector.getRequestParams)
	const gridLoading = useSelector(gridSelectors.selectGridLoading)
	const expandId = useSelector(interfaceElementsSelector.getExpandId)

	useEffectOnce(() => {
		getAll({ params: new RequestParams(1, 1000, null) })
	})

	return (
		<div>
			<GridWrapper
				getItems={getAll}
				requestParams={params}
				data={roleElements}
				total={0}
				loading={gridLoading}
				renderGridRow={(props: RenderGridRowProps<InterfaceElementModel>) => (
					<GridRow
						columns={gridConfigIE.columns}
						CustomColumnsComponent={CustomColumns}
						opened={expandId}
						OpenedComponent={OpenedComponent}
						{...props}
					/>
				)}
				renderGridHeader={() => <CustomHeader columns={gridConfigIE.columns} />}
			/>
		</div>
	)
}
